// Azure AD configuratie voor Outlook agenda-sync
// De admin vult Client ID en Tenant ID in via Beheer → Instellingen
// Config wordt opgeslagen in zowel localStorage (snel) als Firestore (cross-device)

import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const STORAGE_KEY = 'slaaploods_azure_config';
const FIRESTORE_DOC = 'settings/azureConfig';

export function getAzureConfig() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch { return null; }
}

/**
 * Laad Azure config uit Firestore (voor nieuwe devices/browsers).
 * Slaat op in localStorage als gevonden.
 */
export async function loadAzureConfigFromFirestore() {
  try {
    const snap = await getDoc(doc(db, FIRESTORE_DOC));
    if (snap.exists()) {
      const config = snap.data();
      if (config?.clientId && config?.tenantId) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
        return config;
      }
    }
  } catch (err) {
    console.warn('Azure config laden uit Firestore:', err);
  }
  return null;
}

export async function saveAzureConfig(config) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  // Ook naar Firestore schrijven voor andere devices
  try {
    await setDoc(doc(db, FIRESTORE_DOC), config);
  } catch (err) {
    console.warn('Azure config opslaan in Firestore:', err);
  }
}

export function clearAzureConfig() {
  localStorage.removeItem(STORAGE_KEY);
}

// MSAL scopes voor agenda-toegang
export const CALENDAR_SCOPES = ['Calendars.ReadWrite', 'User.Read'];

// Graph API endpoints
export const GRAPH_BASE = 'https://graph.microsoft.com/v1.0';
